import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  toggleFoldedRows() {
    const unfolding = this.element.classList.toggle("fap-unfolded")
    const button = this.buttonTarget

    button.textContent = unfolding ? button.dataset.lessLabel : button.dataset.moreLabel
  }
}
